import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

const LoadingComponent = <LinearProgress style={{ height: 1 }} />;

export default LoadingComponent;
